document.addEventListener("DOMContentLoaded",()=>{
  const $=s=>document.querySelector(s), $$=s=>document.querySelectorAll(s);
  const cart=$("#CartDrawer"), veil=$(".drawer-overlay"), search=$("#SearchPanel"), menu=$("#MobileMenu");

  const openCart=()=>{cart?.classList.add("open");cart?.setAttribute("aria-hidden","false")};
  const closeCart=()=>{cart?.classList.remove("open");cart?.setAttribute("aria-hidden","true")};
  const openSearch=()=>{search?.classList.add("open");search?.setAttribute("aria-hidden","false");setTimeout(()=>$("#SearchInput")?.focus(),120)};
  const closeSearch=()=>{search?.classList.remove("open");search?.setAttribute("aria-hidden","true")};

  $$("[data-open-cart]").forEach(b=>b.addEventListener("click",openCart));
  $$("[data-close-cart]").forEach(b=>b.addEventListener("click",closeCart));
  $$("[data-open-search]").forEach(b=>b.addEventListener("click",openSearch));
  $$("[data-close-search]").forEach(b=>b.addEventListener("click",closeSearch));
  $$("[data-open-menu]").forEach(b=>b.addEventListener("click",()=>menu?.classList.add("open")));
  $$("[data-close-menu]").forEach(b=>b.addEventListener("click",()=>menu?.classList.remove("open")));

  async function refreshCart(){
    const r=await fetch(window.Shopify.routes.root+"cart.js"); const c=await r.json();
    const count=$("#CartCount"); if(count) count.textContent=c.item_count;
    const sub=$("#CartSubtotal"); if(sub) sub.textContent=Shopify.formatMoney(c.total_price);
  }

  $$("[data-quick-add]").forEach(btn=>btn.addEventListener("click",async e=>{
    e.preventDefault(); e.stopPropagation();
    const id=btn.dataset.quickAdd; if(!id)return;
    btn.disabled=true; const old=btn.textContent; btn.textContent="Adding…";
    try{
      await fetch(window.Shopify.routes.root+"cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})});
      await refreshCart(); btn.textContent="Added ✓"; openCart();
      setTimeout(()=>{btn.textContent=old;btn.disabled=false},1100);
    }catch(err){btn.textContent="Try again";btn.disabled=false}
  }));

  $$("[data-remove-line]").forEach(btn=>btn.addEventListener("click",async()=>{
    await fetch(window.Shopify.routes.root+"cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({line:Number(btn.dataset.removeLine),quantity:0})});
    location.reload();
  }));

  $("#ProductForm")?.addEventListener("submit",async e=>{
    e.preventDefault(); const form=e.currentTarget; const fd=new FormData(form);
    const body={items:[{id:Number(fd.get("id")),quantity:1}]};
    try{await fetch(window.Shopify.routes.root+"cart/add.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify(body)});await refreshCart();openCart()}catch(err){form.submit()}
  });

  const input=$("#SearchInput"), results=$("#SearchSuggestions");
  input?.addEventListener("input",async()=>{
    const q=input.value.trim(); if(!q){results.innerHTML="";return}
    try{
      const r=await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide`);
      const data=await r.json(), items=data.resources?.results?.products||[];
      results.innerHTML=items.map(p=>`<a class="suggestion" href="${p.url}">${p.title}</a>`).join("");
    }catch(e){}
  });
});